/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

var _span, _span2, _span3;
function StructuredListSkeleton(_ref) {
  let {
    rowCount = 5,
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const classNames = cx(`${prefix}--skeleton`, `${prefix}--structured-list`, className);
  const rows = new Array(rowCount).fill(null).map((_, i) => /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--structured-list-row`,
    key: i
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--structured-list-td`
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--structured-list-td`
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--structured-list-td`
  })));
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classNames
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--structured-list-thead`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--structured-list-row ${prefix}--structured-list-row--header-row`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--structured-list-th`
  }, _span || (_span = /*#__PURE__*/React__default.createElement("span", null))), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--structured-list-th`
  }, _span2 || (_span2 = /*#__PURE__*/React__default.createElement("span", null))), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--structured-list-th`
  }, _span3 || (_span3 = /*#__PURE__*/React__default.createElement("span", null))))), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--structured-list-tbody`
  }, rows));
}
StructuredListSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,
  /**
   * number of table rows
   */
  rowCount: PropTypes.number
};

export { StructuredListSkeleton as default };
